import { gql } from '@apollo/client';

export const callMeAdditional = gql`mutation callMeAdditional($input: CallMeInput!) {
  callMe(input: $input)
}
`